import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "amino_token";

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Global 401 handler for admin force-logout: when the backend rejects a token
// because an admin stamped `force_logout_at` on the user, clear the local token
// and bounce back to /login. Only fires for the specific "Session revoked"
// detail so it never disrupts the login screen's own 401-on-bad-password flow.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail;
    if (
      status === 401 &&
      typeof detail === "string" &&
      detail.toLowerCase().includes("session revoked")
    ) {
      try { localStorage.removeItem(TOKEN_KEY); } catch (_) {}
      const path = window.location.pathname;
      if (path !== "/login" && path !== "/signup" && !path.startsWith("/reset-password")) {
        window.location.replace("/login?session_revoked=1");
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
